import { FC, ReactElement } from 'react'

import { Button, Card } from '@/components'
import { trans } from '@/helpers/trans'

import './DirectMessagesEmptyState.scss'

interface DirectMessagesEmptyStateProps {
    onStartChat: () => void
}

export const DirectMessagesEmptyState: FC<DirectMessagesEmptyStateProps> = ({
    onStartChat,
}): ReactElement => (
    <Card className="direct-messages-empty-state">
        <p className="direct-messages-empty-state__text">
            {trans('pages.messages.noDirectMessages')}
        </p>

        <Button
            text={trans('pages.messages.startFirstChat')}
            onClick={onStartChat}
            className="direct-messages-empty-state__button"
        />
    </Card>
)
